import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ADMIN_BASE } from "@admin/constants/route";

/**
 * Gates the admin shell behind a successful 2FA verification.
 *
 *   - If the admin's `two_factor_enabled` is false → pass through (opted-out
 *     non-mandatory admin).
 *   - If `two_factor_satisfied` is true → pass through.
 *   - Otherwise → redirect to /<ADMIN_BASE>/verify carrying the original path
 *     so the user lands back where they were going post-verify.
 *
 * This component assumes RequirePermission has already validated session +
 * role, so we only need the 2FA bit here.
 */
export default function RequireTwoFactor({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!user || user.role !== "admin") return null;
  if (!user.two_factor_enabled || user.two_factor_satisfied) return children;

  return (
    <Navigate
      to={`${ADMIN_BASE}/verify`}
      replace
      state={{ from: location.pathname + location.search }}
    />
  );
}
